export function numericKeysOnly(event): boolean {
	// Allow control keys
	if (event.ctrlKey || event.metaKey || event.altKey) {
		return true;
	}
	const key = event.key;
	// Allow navigation/control keys
	if (key.length > 1) {
		return true;
	}
	// Allow only digits
	if (/^[0-9]$/.test(key)) {
		return true;
	}
	event.preventDefault();
	return false;
}
